import { ServicesMultiChoiceWUT } from '@wix/form-fields/viewer-wut';

export default ServicesMultiChoiceWUT;
